import React, { useState, createContext, useContext } from 'react';
// === DEMO DATA ===
// Richieste seed fittizie per dare contenuto demo al pannello
// "Richieste in arrivo". Rimuovere (set a false) per comportamento
// produzione dove l'utente parte con zero richieste.
const SEED_FAKE_REQUESTS = true;
export type TimeSlot = {
  id: string;
  dayKey: string; // i18n key, e.g. 'meeting.slot.may8'
  timeKey: string; // i18n key, e.g. 'meeting.slot.morning'
};
export const AVAILABLE_SLOTS: TimeSlot[] = [{
  id: 'may8-am',
  dayKey: 'meeting.day.may8',
  timeKey: 'meeting.time.morning'
}, {
  id: 'may8-pm',
  dayKey: 'meeting.day.may8',
  timeKey: 'meeting.time.afternoon'
}, {
  id: 'may9-am',
  dayKey: 'meeting.day.may9',
  timeKey: 'meeting.time.morning'
}, {
  id: 'may9-pm',
  dayKey: 'meeting.day.may9',
  timeKey: 'meeting.time.afternoon'
}];
export type RequestStatus = 'pending-outgoing' | 'pending-incoming' | 'accepted';
export interface MeetingRequest {
  id: string;
  profileId: string; // the other party's profile id
  slotId: string;
  status: RequestStatus;
  alternativeSlotId?: string;
  createdAt: number;
}
interface Ctx {
  requests: MeetingRequest[];
  sendRequest: (profileId: string, slotId: string) => void;
  acceptRequest: (requestId: string) => void;
  proposeAlternative: (requestId: string, slotId: string) => void;
  resetRequests: () => void;
}
const MeetingRequestsContext = createContext<Ctx | undefined>(undefined);
// Seed with a couple of incoming requests so the Connections page has something to show.
// Demo-only — gated behind SEED_FAKE_REQUESTS.
const SEED_REQUESTS: MeetingRequest[] = [{
  id: 'seed-incoming-1',
  profileId: 'p7',
  slotId: 'may8-am',
  status: 'pending-incoming',
  createdAt: Date.now() - 3600000
}, {
  id: 'seed-incoming-2',
  profileId: 'p22',
  slotId: 'may9-pm',
  status: 'pending-incoming',
  createdAt: Date.now() - 1800000
}];
export function MeetingRequestsProvider({
  children
}: {
  children: ReactNode;
}) {
  const [requests, setRequests] = useState<MeetingRequest[]>(SEED_FAKE_REQUESTS ? SEED_REQUESTS : []);
  const sendRequest = (profileId: string, slotId: string) => {
    setRequests(prev => [...prev, {
      id: `req-${Date.now()}`,
      profileId,
      slotId,
      status: 'pending-outgoing',
      createdAt: Date.now()
    }]);
  };
  const acceptRequest = (requestId: string) => {
    setRequests(prev => prev.map(r => r.id === requestId ? {
      ...r,
      status: 'accepted'
    } : r));
  };
  const proposeAlternative = (requestId: string, slotId: string) => {
    setRequests(prev => prev.map(r => r.id === requestId ? {
      ...r,
      alternativeSlotId: slotId,
      status: 'pending-outgoing'
    } : r));
  };
  const resetRequests = () => {
    setRequests(SEED_FAKE_REQUESTS ? SEED_REQUESTS : []);
  };
  return <MeetingRequestsContext.Provider value={{
    requests,
    sendRequest,
    acceptRequest,
    proposeAlternative,
    resetRequests
  }} data-id="element-155">
      {children}
    </MeetingRequestsContext.Provider>;
}
export function useMeetingRequests() {
  const ctx = useContext(MeetingRequestsContext);
  if (!ctx) throw new Error('useMeetingRequests must be used within provider');
  return ctx;
}